(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodTemplate', sodTemplate);

    function sodTemplate() {
        return {
            restrict: 'E',
            scope: {
                template: '=',
                data: '=?'
            },
            controller: sodTemplateCtrl
        };
    }

    function sodTemplateCtrl($compile, $scope, $element) {
        this.$onInit = function() {
            $element.html($scope.template);
            const cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', ()=> {
                cloneElement.off();
            });
        }
    }
})();